<template>
    <div class="text-area-default">
        <textarea 
            id="textArea"
            name="text-area" 
            class="text-area"
            v-model="textAreaMessage"
            :class="classObject"

            :placeholder="placeholder">
        </textarea>
        <!-- <span>{{textAreaMessage}}</span> -->
    </div>
</template>
<script>
// import { Bus } from '../../../event-bus.js'
export default {
    data(){
        return{
            buttonStatus : false,
            colors:{},
            textAreaMessage: ''

        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));

    },
    props: {
        placeholder : {
            type : String,
            required : true
        }
    },
    computed:{
        classObject: function(){
            return{
                active: this.textAreaMessage,
                dark: this.colors.theme == 'dark' ? true : false
            }
        }
    },
    methods: {
            //         :style="{
            //     border: colors.theme == 'dark' ? '1px solid #fff' : '1px solid #000',
            // }"
        // verifyValue(event){
        //     let tamanho = event.length
        //     if(tamanho > 0){
        //         if(this.buttonStatus == false){
        //             this.buttonStatus = true
        //             Bus.$emit('ableButton')
        //         }
        //     }
        //     if(tamanho == 0){
        //         Bus.$emit('disableButton')
        //         this.buttonStatus = false
        //     }
        // }
    }
}
</script>
<style lang="scss" scoped>
    .text-area-default{
        width: 100%;
        display: flex;
        justify-content: center;    
        padding: 0 0 32px 0;


        .text-area{
            box-sizing: border-box;
            resize: none;
            border-radius: 10px;
            border: none;
            width: 90%;
            max-width: 500px;
            height: 250px;
            padding: 5%;
            background: transparent;
            border: 1px solid;
        }
        .text-area.active.dark{
            font-weight: 700;
            font-size: 17px;
            background-color: #001324;
            color: #14FBF0;
            border: none;
        }
        .text-area.dark{
            color: #14FBF0;
            border: 1px solid #fff;
            &::placeholder{
                color: #fff;
                font-size: 12px;
                font-weight: 800;
            }
        }

        .text-area.active{
            font-weight: 700;
            font-size: 17px;
            background-color: #fff;
            color: #000;
            border: none;

            &::placeholder{
                color: #000;
                font-size: 12px;
            }            
        }
    }
</style>
